import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

export default function Report() {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const API_BASE_URL = "https://prodapi.iworkkz.com:9095";

  // ✅ RAW BASE64 KEY
  const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";

  // ================= OTP INPUT HANDLERS =================
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  // ================= SEND OTP =================
  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!phone || phone.length < 6) {
      toast.error("Enter valid mobile number");
      return;
    }

    try {
      setLoading(true);

      const sendRes = await fetch(
        `${API_BASE_URL}/api/otp/send?mobile=${encodeURIComponent(
          phone
        )}&key=${API_KEY}`,
        { method: "POST" }
      );

      const sendData = await sendRes.json();

      if (sendData.success) {
        toast.success(sendData.message || "OTP sent");
        setOtpSent(true);
      } else {
        toast.error(sendData.message || "Failed to send OTP");
      }
    } catch {
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  // ================= VERIFY OTP =================
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      toast.error("Enter valid 6-digit OTP");
      return;
    }

    try {
      setLoading(true);

      const verifyRes = await fetch(
        `${API_BASE_URL}/api/otp/verify?mobile=${encodeURIComponent(
          phone
        )}&otp=${encodeURIComponent(finalOtp)}&&key=${API_KEY}`,
        { method: "POST" }
      );

      const verifyData = await verifyRes.json();

      if (verifyData.success) {
        toast.success(verifyData.message || "Login successful");
        navigate("/landing");
      } else {
        toast.error(verifyData.message || "Invalid or expired OTP");
      }
    } catch {
      toast.error("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5 d-flex justify-content-center">
      <div
        className="card border p-4"
        style={{ width: "360px", borderRadius: "14px" }}
      >
        <h4 className="text-center fw-bold mb-1">Welcome Back</h4>
        <p className="text-center text-muted mb-4" style={{ fontSize: "14px" }}>
          Login using your WhatsApp number
        </p>

        {!otpSent ? (
          /* ================= MOBILE NUMBER ================= */
          <form onSubmit={handleSendOtp}>
            <div className="mb-3">
              <PhoneInput
                country="in"
                enableSearch
                value={phone}
                onChange={setPhone}
                inputClass="form-control"
                containerClass="w-100"
                inputStyle={{ height: "42px" }}
              />
            </div>

            <button
              type="submit"
              className="btn btn-dark w-100 py-2"
              disabled={loading}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
        ) : (
          /* ================= OTP ================= */
          <form onSubmit={handleVerifyOtp}>
            <div className="d-flex justify-content-between mb-3">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  className="form-control text-center fw-bold"
                  style={{
                    width: "45px",
                    height: "45px",
                    fontSize: "18px",
                  }}
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                />
              ))}
            </div>

            <small className="text-muted d-block text-center mb-2">
              OTP sent to WhatsApp
            </small>

            <button
              type="submit"
              className="btn btn-success w-100 py-2 mb-2"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Login"}
            </button>

            {/* ✅ BACK BUTTON */}
            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={() => {
                setOtp(["", "", "", "", "", ""]);
                setPhone("");
                setOtpSent(false);
              }}
            >
              ← Back to Login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
